import apiHttpClient from "libs/api-http-client";
import { RecommendedCharityInput } from "types/recommended-charity";

export const addRecommendedCharityAPI = (
  recommendedCharityInput: RecommendedCharityInput
): Promise<unknown> =>
  apiHttpClient.post(`recommended-charity`, recommendedCharityInput);
